import React from 'react';
import propTypes from './propTypes';

const AboutCarMovement = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="5" y="15" width="11" height="4" fill="white" />
    <circle cx="5.5" cy="16.5" r="1.5" fill="currentColor" />
    <circle cx="12.5" cy="16.5" r="1.5" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M10.9984 2H4C2.34315 2 1 3.34315 1 5V22C1 22.5523 1.44772 23 2 23H4C4.55228 23 5 22.5523 5 22V21H13V22C13 22.5523 13.4477 23 14 23H16C16.5523 23 17 22.5523 17 22V12H3V10.6348L4.85984 8H12.4993L14.0001 6H4.34169C4.01676 6 3.7121 6.15787 3.52472 6.42332L3 7.16667V5C3 4.44772 3.44772 4 4 4H12.4993L10.9984 2ZM15 14H3V18C3 18.5523 3.44772 19 4 19H14C14.5523 19 15 18.5523 15 18V14Z" fill="currentColor" />
    <path d="M13 2H15.7273L18.7576 6L15.7273 10H13L16.0303 6L13 2Z" fill="currentColor" />
    <path d="M17.2424 2H19.9697L23 6L19.9697 10H17.2424L20.2727 6L17.2424 2Z" fill="currentColor" />
  </svg>
);

AboutCarMovement.propTypes = propTypes;

export default AboutCarMovement;
